import { render } from "./HighlightedText.vue?vue&type=template&id=70a821e3"
import script from "./HighlightedText.vue?vue&type=script&lang=js"
export * from "./HighlightedText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__